module.exports = __webpack_public_path__ + "img/kjyr-title.ca83467b.png";